import { render, staticRenderFns } from "./ArabicContractZaitonPlusCity.vue?vue&type=template&id=2397ffd8&scoped=true&"
import script from "./ArabicContractZaitonPlusCity.vue?vue&type=script&lang=js&"
export * from "./ArabicContractZaitonPlusCity.vue?vue&type=script&lang=js&"
import style0 from "./ArabicContractZaitonPlusCity.vue?vue&type=style&index=0&id=2397ffd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397ffd8",
  null
  
)

export default component.exports